import { pathOr } from 'ramda'
import { combineReducers } from 'redux'
import { combineActions, handleActions } from 'redux-actions'

import * as actions from './actions'

const plan = handleActions(
  {
    [actions.setPlan]: (state, action) => action.payload,
  },
  false
)

const coupon = handleActions(
  {
    [actions.setCoupon]: (state, action) => action.payload,
  },
  false
)

const useNetsuite = handleActions(
  {
    [actions.setUseNetsuite]: (state, action) => action.payload,
  },
  true
)

const activateDealStatus = handleActions(
  {
    [combineActions(
      actions.activateDeal,
      actions.activateDealSuccess,
      actions.activateDealPending,
      actions.activateDealFailed
    )]: (state, action) => action.type,
  },
  false
)

const billingDealStatus = handleActions(
  {
    [combineActions(
      actions.fetchDeal,
      actions.fetchDealSuccess,
      actions.fetchDealPending,
      actions.fetchDealFailed
    )]: (state, action) => action.type,
  },
  false
)

const billingDeal = handleActions(
  {
    [actions.fetchDealSuccess]: (state, action) => action.payload,
  },
  {}
)

const activateDealErrorMessage = handleActions(
  {
    [actions.activateDealFailed]: (state, action) =>
      pathOr(null, ['payload', 'response', 'message'], action),
  },
  null
)

export default combineReducers({
  billingDealStatus,
  billingDeal,
  activateDealStatus,
  activateDealErrorMessage,
  plan,
  coupon,
  useNetsuite,
})
